import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { OfferFormT } from "./types";
import dayjs from "dayjs";
import { useGetOrderByMovement } from "../../../../services";
import React, { Fragment, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";

const isInvalidOrderDate = (orderDate?: string): boolean => {
  if (orderDate && dayjs(orderDate).isValid()) {
    const shipDate = dayjs(orderDate)
      .set("minute", 0)
      .set("second", 0)
      .set("hour", 0)
      .set("millisecond", 0);
    const today = dayjs()
      .set("minute", 0)
      .set("second", 0)
      .set("hour", 0)
      .set("millisecond", 0);
    const daysToShipAmount = shipDate.diff(today, "day");

    return daysToShipAmount > 5;
  }

  return false;
};

const OrderDetails = (): React.ReactElement => {
  const { control } = useFormContext<OfferFormT>();
  const [order] = useWatch({
    control,
    name: ["order"],
  });

  const { data, isSuccess, isLoading } = useGetOrderByMovement(
    order?.movementNumber ?? "",
    { enabled: !!order?.movementNumber }
  );

  const invalidOrderDate = useMemo(
    (): boolean =>
      isInvalidOrderDate(data?.data?.loads_origin.arrive_early_datetime),
    [data]
  );

  return order ? (
    invalidOrderDate ? (
      <div className="mt-2 flex w-full justify-start text-[10px]">
        <span className="rounded-[5px] bg-red-500 px-3 py-1 font-medium text-white">
          Order ships in more than 5 days
        </span>
      </div>
    ) : (
      <section className="mt-2 grid grid-flow-col justify-between gap-[10px] rounded-[5px] bg-[#3C7CF338] px-[12px] py-[4px] text-[10px]">
        <span className="text-[#484848]">GS Rate</span>
        <span className="font-[700] text-[#000000]">
          {isSuccess && !isLoading ? (
            data?.data?.lookup_rate ? (
              `${data.data.lookup_rate.toLocaleString("en-US")} USD`
            ) : (
              "- -"
            )
          ) : (
            <AiOutlineLoading3Quarters className="m-0 h-4 w-4 animate-spin p-0" />
          )}
        </span>
      </section>
    )
  ) : (
    <Fragment />
  );
};

export { isInvalidOrderDate, OrderDetails };
